export type CircleChartDataWrapper = {
  title: string;
  data: CircleChartData[];
};

export type CircleChartData = {
  color: string[];
  id: string;
  label?: string;
  legend: string;
  value: number;
  upperLabel?: string;
  explanation?: string;
};

export enum DATASET_SOURCE_COLORS {
  saveflowAmount = '#55E2F5',
  extraPaymentsAmount = '#56A8EE',
  payflowPlusProcessingAmount = '#5672E7',
  saveflowCount = '#55E2F5',
  extraPaymentsCount = '#56A8EE',
  payflowPlusProcessingCount = '#5672E7',
  summary = '#55E2F5'
}
